<div #containerTitle hidden></div>

<app-theme-designer *ngIf="showDesigner"></app-theme-designer>
<ng-container *ngIf="initError; then error; else app"></ng-container>

<ng-template #error>
  <div class="error">
    <app-svg-image type="initError"></app-svg-image>

    <div class="text">
      <h2>{{ 'messages.error.connectionNotAvailable' | translate }}</h2>
      <p>{{ 'messages.error.sorryInconvinience' | translate }}</p>
    </div>
  </div>
</ng-template>

<ng-template #app>
  <div class="top">
    <smart-banner></smart-banner>
    <app-header></app-header>
  </div>

  <main
    [class.open]="openSidebar"
    [class.home]="isHome"
    [class.is-results-page]="isResultsPage"
    [class.is-record-info]="isRecordInfo"
    [class.main--reduced-margin-bottom]="shouldReduceMarginBottom">
    <ng-progress [color]="'var(--progress-bar-background)'" [spinner]="false"></ng-progress>
    <notifier-container></notifier-container>
    <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate($event)"></router-outlet>
  </main>
  <app-assistant *ngIf="assistantActive"></app-assistant>
  <app-footer (language)="onLanguageSelected($event)"></app-footer>
  <app-sidebar [class.with-banner]="withBanner" [ngClass]="headerType"></app-sidebar>
  <app-scroll-to-top></app-scroll-to-top>
</ng-template>

<app-modal-handler></app-modal-handler>
<app-terms-conditions-dialog #termsConditionsDialog></app-terms-conditions-dialog>
<app-recommend-platform-dialog #recommendPlatformDialog></app-recommend-platform-dialog>
<opac-confirmation-dialog
  [acceptLabel]="'general.accept'"
  [cancelLabel]="undefined"
  [open]="showConfirmationEmailDialog()"
  [title]="'login.validated.user' | translate"
  (accept)="closeConfirmationEmailDialog()"
  (cancel)="closeConfirmationEmailDialog()">
  <p>{{ confirmationEmailLabel() | translate }}</p>
</opac-confirmation-dialog>
<opac-reset-password-dialog #resetPasswordDialog (submit)="handleResetPasswordDialog()"></opac-reset-password-dialog>

<opac-toaster></opac-toaster>
